import React, { useEffect, useState } from "react";
import ChatsContentWeb from "./ChatsContentWeb";
import ChatsContent from "./ChatsContent";
import { ChatsContextImport } from "../../../provider/chats/chats/chats/ChatsContextProvider";
import Center from "../../../widget/common/ui/Center";
import Loader from "../../../widget/common/ui/Loader";
import NoData from "../../../widget/common/ui/NoData";

const ChatsScreenBody = (props: { type: number }) => {
  const type = props.type;

  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const {
    getChatListAPI,
    chatsOrig,
    chats,
    chatSelected,
    loadingMesages,
    socketStatus,
  } = ChatsContextImport();

  useEffect(() => {
    getChatListAPI();

    const handleResize = () => {
      setSize({ width: window.innerWidth, height: window.innerHeight });
    };

    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => window.removeEventListener("resize", handleResize);
    // eslint-disable-next-line
  }, []);

  return (
    <div className={`h-100 position-relative`}>
      {chatsOrig == null && !socketStatus ? (
        <Center className="h-100">{Loader.normal()}</Center>
      ) : chatsOrig!.length === 0 ? (
        <Center className="h-100">
          <NoData />
        </Center>
      ) : (
        <>
          {type === 3 ? (
            <ChatsContentWeb
              chats={chats}
              type={type}
              browserWidth={size.width}
              chatSelected={chatSelected}
              loadingMesages={loadingMesages}
            />
          ) : (
            <ChatsContent chats={chats} type={type} />
          )}
        </>
      )}
    </div>
  );
};

export default ChatsScreenBody;
